import _Dialoger from "@kibt/meta-ui/es/dialog/dialoger";
import cookies from 'js-cookie';
import dayjs from 'dayjs';
import { nextTick } from '@vue/composition-api';
import { isIOS } from '@/utils/platform';
import { isInApp } from '@/utils/yoda';
import { toAppLogin } from '@/utils/outside-login';
import i18n from './k18n';
import { logger } from '@/utils/logger';
export var allowFissionIos = function allowFissionIos(force) {
  if (force) {
    return true;
  } // IOS在端内不能打开


  if (isIOS() && isInApp) {
    var url = new URL("".concat(location.origin, "/creator/center/fission/ios"));
    url.searchParams.set('source', window.location.origin + window.location.pathname);
    url.searchParams.set('referUrl', window.location.href);
    window.location.replace(url.href);
    return false;
  }

  return true;
};
export var toCommonFissionAppLogin = function toCommonFissionAppLogin() {
  var referUrl = new URL("".concat(window.location.origin, "/creator/center/fission"));
  toAppLogin(referUrl.href);
};
export var offLineBuckets = ['pak', 'egy', 'spa', 'br', 'in']; // 正式下线时间

var offlineDateTimeMap = {
  pak: 1666540800000,
  egy: 1672329600000,
  spa: 1672329600000,
  br: 1672329600000,
  in: 1678982400000
}; // 正式创作者钱包提现截止时间

export var offlineWithdrawTimeMap = {
  pak: 1675094400000,
  egy: 1674230400000,
  spa: 1674230400000,
  br: 1674230400000,
  in: 1680105600000
}; // 下线弹窗的文案

export var getOfflinePopupDesc = function getOfflinePopupDesc(bucket) {
  return i18n.t('k_210218', {
    // 兜个底
    Activitiy_time: offlineDateTimeMap[bucket] ? dayjs(offlineDateTimeMap[bucket]).format(i18n.t('creator_month_day')) : '--',
    // 兜个底
    Withdrawal_time: offlineWithdrawTimeMap[bucket] ? dayjs(offlineWithdrawTimeMap[bucket]).format(i18n.t('creator_month_day')) : '--'
  });
};
export var judgeOffline = function judgeOffline(bucketParam) {
  var bucket = bucketParam || cookies.get('bucket') || '';
  var uid = cookies.get('userId') || cookies.get('ud') || '';

  if (offLineBuckets.includes(bucket)) {
    var nowDate = new Date().getTime();
    var offlineDateTime = offlineDateTimeMap[bucket] || 0;

    if (nowDate > offlineDateTime) {
      window.location.replace("".concat(window.location.origin, "/creator/center/fission/offline"));
      return false;
    }

    var dialogFlag = false; // 控制一天下发一次

    var lastPopupTimeString = localStorage.getItem("fission_dialog_uid_".concat(uid));

    if (!lastPopupTimeString) {
      dialogFlag = true;
      localStorage.setItem("fission_dialog_uid_".concat(uid), nowDate.toString());
    } else {
      var lastPopupTime = Number(lastPopupTimeString);
      var lastPopupDay = dayjs(lastPopupTime); // 如果今天没弹

      if (!lastPopupDay.isSame(new Date(), 'day')) {
        dialogFlag = true;
        localStorage.setItem("fission_dialog_uid_".concat(uid), nowDate.toString());
      }
    }

    if (dialogFlag) {
      nextTick(function () {
        logger.kwailog.sendShow({
          action: 'NOTICE_POP'
        });

        _Dialoger.alert({
          content: getOfflinePopupDesc(bucket),
          okText: i18n.t('common_ok'),
          onOk: function onOk() {
            logger.kwailog.sendClick({
              action: 'NOTICE_POP'
            });
          }
        });
      });
    }
  }

  return true;
};
export var judgeOfflineForHome = function judgeOfflineForHome(bucketParam) {
  var bucket = bucketParam || cookies.get('bucket') || '';
  var uid = cookies.get('userId') || cookies.get('ud') || '';

  if (offLineBuckets.includes(bucket)) {
    var nowDate = new Date().getTime();
    var offlineDateTime = offlineDateTimeMap[bucket] || 0;

    if (nowDate > offlineDateTime) {
      // window.location.replace(`${window.location.origin}/creator/center/fission/offline`) ;
      return false;
    }

    var dialogFlag = false; // 控制一天下发一次

    var lastPopupTimeString = localStorage.getItem("fission_dialog_uid_".concat(uid));

    if (!lastPopupTimeString) {
      dialogFlag = true;
      localStorage.setItem("fission_dialog_uid_".concat(uid), nowDate.toString());
    } else {
      var lastPopupTime = Number(lastPopupTimeString);
      var lastPopupDay = dayjs(lastPopupTime); // 如果今天没弹

      if (!lastPopupDay.isSame(new Date(), 'day')) {
        dialogFlag = true;
        localStorage.setItem("fission_dialog_uid_".concat(uid), nowDate.toString());
      }
    }

    if (dialogFlag) {
      nextTick(function () {
        logger.kwailog.sendShow({
          action: 'NOTICE_POP'
        });

        _Dialoger.alert({
          content: getOfflinePopupDesc(bucket),
          okText: i18n.t('common_ok'),
          onOk: function onOk() {
            logger.kwailog.sendClick({
              action: 'NOTICE_POP'
            });
          }
        });
      });
    }
  }

  return true;
};
export var allowFissionIosForHome = function allowFissionIosForHome(force) {
  if (force) {
    return true;
  } // IOS在端内不能打开


  if (isIOS() && isInApp) {
    // const url = new URL(`${location.origin}/creator/center/fission/ios`);
    // url.searchParams.set('source', window.location.origin + window.location.pathname);
    // url.searchParams.set('referUrl', window.location.href);
    // window.location.replace(url.href);
    return false;
  }

  return true;
};